(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["banner-scheduler"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('banner-scheduler')) return;

    function wallTime(formatter, timestamp) {
      const parts = Object.fromEntries(formatter.formatToParts(timestamp).map(part => [part.type, part.value]));
      return Date.UTC(+parts.year, +parts.month - 1, +parts.day, +parts.hour, +parts.minute);
    }

    function parseDate(value, formatter) {
      if (!/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}$/.test(value)) return NaN;
      const [year, month, day, hour, minute] = value.match(/\d+/g).map(Number);
      const wall = Date.UTC(year, month - 1, day, hour, minute);
      if (year < 2000 || new Date(wall).toISOString().slice(0, 16).replace('T', ' ') !== value) return NaN;
      const offsets = new Set([-36, 0, 36].map(hours => {
        const sample = wall + hours * 3600000;
        return wallTime(formatter, sample) - sample;
      }));
      const matches = [...offsets].map(offset => wall - offset).filter(time => wallTime(formatter, time) === wall);
      return matches.length === 1 ? matches[0] : NaN;
    }

    class BannerScheduler extends HTMLElement {
      connectedCallback() {
        this.source = this.querySelector(':scope > template[data-banner-schedule-template]');
        this.section = this.closest('.shopify-section');
        if (!this.source || !this.section) return;
        this.editor = this.dataset.editor === 'true';
        let formatter;
        try {
          formatter = new Intl.DateTimeFormat('en-GB', {
            timeZone: this.dataset.timezone, year: 'numeric', month: '2-digit', day: '2-digit',
            hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
          });
        } catch {}
        this.schedules = Array.from(this.source.content.querySelectorAll('[data-banner-schedule]')).map(item => {
          if (item.dataset.bannerSchedule !== 'true') return { start: -Infinity, end: Infinity, valid: true };
          const start = formatter ? parseDate(item.dataset.scheduleStart.trim(), formatter) : NaN;
          const endText = item.dataset.scheduleEnd.trim();
          const end = endText ? (formatter ? parseDate(endText, formatter) : NaN) : Infinity;
          return { start, end, valid: Number.isFinite(start) && end > start };
        });
        this.signature = null;
        this.abortController = new AbortController();
        const refresh = () => this.update();
        document.addEventListener('visibilitychange', refresh, { signal: this.abortController.signal });
        window.addEventListener('pageshow', refresh, { signal: this.abortController.signal });
        window.addEventListener('focus', refresh, { signal: this.abortController.signal });
        this.update();
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
        this.abortController?.abort();
        this.section?.removeAttribute('data-banner-schedule-visible');
      }

      update() {
        clearTimeout(this.timer);
        const now = Date.now();
        const active = this.schedules.map(schedule => this.editor || (schedule.valid && now >= schedule.start && now < schedule.end));
        const signature = active.join(',');
        if (signature !== this.signature) {
          this.signature = signature;
          this.render(active);
        }
        if (!this.editor) {
          const boundaries = this.schedules.filter(schedule => schedule.valid).flatMap(schedule => [schedule.start, schedule.end]).filter(time => time > now && Number.isFinite(time));
          if (boundaries.length) {
            this.timer = setTimeout(() => this.update(), Math.min(60000, Math.max(1, Math.min(...boundaries) - now)));
          }
        }
      }

      render(active) {
        const currentId = this.querySelector('.slideshow__slide.is-selected')?.id;
        const hadFocus = this.contains(document.activeElement);
        const fragment = this.source.content.cloneNode(true);
        const items = Array.from(fragment.querySelectorAll('[data-banner-schedule]'));
        items.forEach((item, index) => { if (!active[index]) item.remove(); });
        const slides = Array.from(fragment.querySelectorAll('.slideshow__slide'));
        const carousel = fragment.querySelector('slideshow-carousel');
        if (carousel && slides.length) {
          const selectedIndex = Math.max(0, slides.findIndex(slide => slide.id === currentId));
          carousel.setAttribute('initial-index', String(selectedIndex));
          slides.forEach((slide, index) => slide.classList.toggle('is-selected', index === selectedIndex));
          const selected = slides[selectedIndex];
          const media = selected.querySelector('template[data-slideshow-media-template]');
          if (media) media.replaceWith(media.content.cloneNode(true));
          selected.querySelectorAll('img').forEach(img => { img.loading = 'eager'; img.fetchPriority = 'high'; });
          fragment.querySelectorAll('page-dots').forEach(dots => {
            Array.from(dots.children).forEach((dot, index) => { if (!active[index]) dot.remove(); });
            Array.from(dots.children).forEach((dot, index) => {
              dot.setAttribute('aria-current', String(index === selectedIndex));
              const number = dot.querySelector('span:not(.sr-only)');
              if (number) number.textContent = String(index + 1);
              const label = dot.querySelector('.sr-only');
              if (label) label.textContent = this.dataset.itemLabel.replace('__index__', String(index + 1));
            });
          });
          fragment.querySelector('x-slideshow')?.classList.toggle('slideshow--multiple-slides', slides.length > 1);
          if (slides.length < 2) fragment.querySelectorAll('.slideshow__controls, .slideshow__cursor').forEach(node => node.remove());
          carousel.removeAttribute('reveal-on-scroll');
        }
        this.querySelectorAll('video').forEach(video => video.pause());
        Array.from(this.children).filter(child => child !== this.source).forEach(child => child.remove());
        this.section.toggleAttribute('data-banner-schedule-visible', active.some(Boolean));
        if (!active.some(Boolean)) return;
        if (this.editor) {
          const notice = document.createElement('div');
          notice.dataset.bannerScheduleNotice = '';
          notice.textContent = this.dataset.previewMessage;
          const invalid = this.schedules.flatMap((schedule, index) => schedule.valid ? [] : [index + 1]);
          if (invalid.length) notice.textContent += ` ${this.dataset.invalidMessage} ${invalid.join(', ')}.`;
          this.append(notice);
        }
        this.append(fragment);
        if (hadFocus) {
          const target = this.querySelector('.slideshow__slide.is-selected') || this.querySelector('[data-banner-schedule]');
          target?.setAttribute('tabindex', '-1');
          target?.focus({ preventScroll: true });
        }
      }
    }
    customElements.define('banner-scheduler', BannerScheduler);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mobile-home-faq"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('vpa-mobile-home-faq')) return;

    class MobileHomeFaq extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.media = matchMedia('(min-width: 700px)');
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.animations = new Map();
        this.addEventListener('click', event => {
          const summary = event.target.closest('.vpa-home-faq__summary');
          if (!summary || !this.contains(summary)) return;
          event.preventDefault();
          const item = summary.parentElement;
          const opening = !item.open || item.hasAttribute('data-closing');
          if (opening) {
            this.querySelectorAll('.vpa-home-faq__item[open]').forEach(other => {
              if (other !== item) this.toggleItem(other, false);
            });
          }
          this.toggleItem(item, opening);
        }, { signal: this.controller.signal });
        this.onMediaChange = () => { if (this.media.matches) this.activateDesktop(); };
        this.media.addEventListener('change', this.onMediaChange);
        this.onMediaChange();
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.media?.removeEventListener('change', this.onMediaChange);
        this.animations?.forEach(animation => animation.cancel());
        this.querySelectorAll('.vpa-home-faq__body').forEach(body => { body.style.opacity = ''; });
        this.querySelectorAll('[data-closing]').forEach(item => {
          item.open = false;
          item.removeAttribute('data-closing');
        });
        this.controller = null;
      }

      toggleItem(item, opening) {
        const body = item.querySelector('.vpa-home-faq__body');
        const start = item.open ? body.getBoundingClientRect().height : 0;
        this.animations.get(item)?.cancel();
        this.animations.delete(item);
        item.toggleAttribute('data-closing', !opening);
        item.open = true;
        body.style.opacity = '';
        if (this.motion.matches || !body.animate) {
          item.open = opening;
          item.removeAttribute('data-closing');
          return;
        }
        const end = opening ? body.getBoundingClientRect().height : 0;
        const frames = Array.from({ length: 21 }, (_, i) => {
          const progress = i / 20;
          const swing = (1 - Math.cos(Math.PI * progress)) / 2;
          return { height: `${start + (end - start) * swing}px`, offset: progress };
        });
        if (opening) body.style.opacity = '0';
        const slide = body.animate(frames, { duration: 200, easing: 'linear' });
        this.animations.set(item, slide);
        slide.onfinish = () => {
          this.animations.delete(item);
          item.open = opening;
          item.removeAttribute('data-closing');
          body.style.opacity = '';
          if (opening) {
            const fade = body.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 500, easing: 'linear' });
            this.animations.set(item, fade);
            fade.onfinish = () => this.animations.delete(item);
          }
        };
      }

      async activateDesktop() {
        if (this.desktopStarted) return;
        this.desktopStarted = true;
        const target = this.querySelector('[data-desktop-faq]');
        const template = this.querySelector('[data-desktop-faq-template]');
        if (!target || !template) return;
        const fragment = template.content.cloneNode(true);
        const scripts = Array.from(fragment.querySelectorAll('script'));
        const pending = scripts.map(script => {
          const marker = document.createComment('desktop-faq-script');
          script.replaceWith(marker);
          return { script, marker };
        });
        const styles = Array.from(fragment.querySelectorAll('link[rel="stylesheet"]')).map(link => new Promise((resolve, reject) => {
          const timer = setTimeout(() => reject(new Error('FAQ stylesheet timed out')), 15000);
          link.onload = () => { clearTimeout(timer); resolve(); };
          link.onerror = () => { clearTimeout(timer); reject(new Error('FAQ stylesheet failed')); };
        }));
        const styleReady = Promise.all(styles);
        styleReady.catch(() => {});
        target.append(fragment);
        try {
          for (const { script: original, marker } of pending) {
            if (!this.isConnected) return;
            const script = document.createElement('script');
            for (const attribute of original.attributes) script.setAttribute(attribute.name, attribute.value);
            script.async = false;
            script.textContent = original.textContent;
            if (original.src) {
              await new Promise((resolve, reject) => {
                const timer = setTimeout(() => reject(new Error('FAQ script timed out')), 15000);
                script.onload = () => { clearTimeout(timer); resolve(); };
                script.onerror = () => { clearTimeout(timer); reject(new Error('FAQ script failed')); };
                marker.replaceWith(script);
              });
            } else {
              marker.replaceWith(script);
            }
          }
          await styleReady;
          if (!this.isConnected) return;
          target.hidden = false;
          this.setAttribute('data-desktop-ready', '');
        } catch (error) {
          this.setAttribute('data-desktop-failed', '');
          console.warn('Desktop FAQ unavailable; native FAQ remains available.', error);
        }
      }
    }
    customElements.define('vpa-mobile-home-faq', MobileHomeFaq);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mobile-product-label-stack"] && !Shopify.designMode) return;
  try {
    (() => {
    const mobile = window.matchMedia('(max-width: 699px)');
    const selector = '.product-gallery__media .bss_pl_img, .product-card__figure .bss_pl_img';
    const originalStyles = new Map();
    let queued = false;

    function setStyle(element, property, value) {
      let saved = originalStyles.get(element);
      if (!saved) {
        saved = new Map();
        originalStyles.set(element, saved);
      }
      if (!saved.has(property)) {
        saved.set(property, [element.style.getPropertyValue(property), element.style.getPropertyPriority(property)]);
      }
      if (element.style.getPropertyValue(property) !== value || element.style.getPropertyPriority(property) !== 'important') {
        element.style.setProperty(property, value, 'important');
      }
    }

    function update() {
      queued = false;
      const active = new Set();

      if (mobile.matches) {
        document.querySelectorAll(selector).forEach((wrapper) => {
          const labels = Array.from(wrapper.children);
          if (labels.length < 2 || !labels.every((label) => label.matches('.bss-pl-top-left'))) return;

          active.add(wrapper);
          if (!wrapper.classList.contains('vpa-mobile-label-stack')) wrapper.classList.add('vpa-mobile-label-stack');
          setStyle(wrapper, 'display', 'flex');
          labels.forEach((label) => {
            active.add(label);
            setStyle(label, 'position', 'relative');
          });
        });
      }

      originalStyles.forEach((properties, element) => {
        if (active.has(element)) return;
        element.classList.remove('vpa-mobile-label-stack');
        properties.forEach(([value, priority], property) => {
          if (value) element.style.setProperty(property, value, priority);
          else element.style.removeProperty(property);
        });
        originalStyles.delete(element);
      });
    }

    function schedule() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(update);
    }

    new MutationObserver((records) => {
      if (records.some((record) => record.type === 'childList' || record.target.closest('.bss_pl_img'))) schedule();
    }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class'] });

    mobile.addEventListener('change', schedule);
    update();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["theme-body-zendesk"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('vpa-support-chat')) return;

    let loadPromise;
    let openPromise;
    let listening = false;
    let resolveOpened;
    const service = {
      hasOpened: false,
      load(url) {
        if (typeof window.zE === 'function') return Promise.resolve();
        if (loadPromise) return loadPromise;
        loadPromise = new Promise((resolve, reject) => {
          let script = document.getElementById('ze-snippet');
          const owned = !script;
          if (!script) {
            script = document.createElement('script');
            script.id = 'ze-snippet';
            script.src = url;
            script.async = true;
          }
          let poll;
          let settled = false;
          const finish = error => {
            if (settled) return;
            settled = true;
            clearTimeout(timer);
            clearTimeout(poll);
            script.removeEventListener('error', failed);
            if (error) {
              if (owned && typeof window.zE !== 'function') script.remove();
              reject(error);
            } else resolve();
          };
          const failed = () => finish(new Error('Support chat script failed'));
          const timer = setTimeout(() => finish(new Error('Support chat script timed out')), 15000);
          const check = () => {
            if (typeof window.zE === 'function') finish();
            else poll = setTimeout(check, 50);
          };
          script.addEventListener('error', failed, { once: true });
          if (owned) document.head.append(script);
          check();
        }).catch(error => { loadPromise = null; throw error; });
        return loadPromise;
      },
      open() {
        if (openPromise) return openPromise;
        const url = document.querySelector('vpa-support-chat')?.dataset.scriptUrl;
        if (!url) return Promise.reject(new Error('Support chat loader unavailable'));
        openPromise = service.load(url).then(() => new Promise((resolve, reject) => {
          const timer = setTimeout(() => {
            resolveOpened = null;
            reject(new Error('Support chat did not open'));
          }, 15000);
          resolveOpened = () => { clearTimeout(timer); resolve(); };
          if (!listening) {
            window.zE('messenger:on', 'open', () => {
              service.hasOpened = true;
              document.querySelectorAll('[data-support-launcher], [data-support-status]').forEach(element => { element.hidden = true; });
              resolveOpened?.();
              resolveOpened = null;
            });
            listening = true;
          }
          window.zE('messenger', 'show');
          window.zE('messenger', 'open');
        })).finally(() => { openPromise = null; });
        return openPromise;
      }
    };
    window.VPASupportChat = service;

    customElements.define('vpa-support-chat', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const launcher = this.querySelector('[data-support-launcher]');
        const status = this.querySelector('[data-support-status]');
        launcher.hidden = service.hasOpened;
        launcher.addEventListener('click', async event => {
          event.preventDefault();
          if (launcher.getAttribute('aria-busy') === 'true') return;
          launcher.setAttribute('aria-busy', 'true');
          status.textContent = status.dataset.loading;
          status.hidden = false;
          try {
            await service.open();
            status.hidden = true;
          } catch (error) {
            status.textContent = status.dataset.error;
            status.hidden = false;
          } finally {
            launcher.removeAttribute('aria-busy');
          }
        }, { signal: this.controller.signal });
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
